import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

export const Container = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const Item = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const ItemTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const ItemName = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  align-items: center;
`;

export const ItemContent = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ItemButtonTax = styled.TouchableOpacity`
  width: 100%;
  text-align: left;
  flex-direction: row;
  align-items: center;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(3)}px;
  margin-top: ${RFValue(3)}px;
`;

export const ItemButtonTaxText = styled.Text`
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(10)}px;
`;

export const IconButtonTax = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(8)}px;
  margin-left: ${RFValue(6)}px;
  margin-top: -3px;
`;
